module.exports = __webpack_public_path__ + "media/9_9.65960be6.wav";